/**
 * An anchor can be triggered by any of these events. See {@link TimeProperties} for more context and {@link Anchor}
 * for examples.
 */
export enum AnchorType {
  /**
   * A special anchor that will always point to „right now”. This can be used if it is desired that a task should always
   * be visible on the current day while it is not yet completed.
   */
  now = 'now',
  /**
   * A fixed timestamp.
   */
  fixed = 'fixed',
  /**
   * The activation of the guide.
   */
  activation = 'activation',
  /**
   * The start or end of a phase, specified by the `id`.
   */
  phase = 'phase',
  /**
   * The start or end of a sensor. Can be filtered by `sensorType` and whether only the `included` sensor or the
   * included sensor of the parent guide should be checked. `index` can specify which sensor exactly should be checked.
   */
  sensor = 'sensor',
  /**
   * The start or end time of a logged task in this guide. If the task occurs multiple times
   * (see {@link TaskRepetition}), an `index` can be used to specify which logged item exactly should be checked.
   */
  task = 'task',
  /**
   * The creation or clearance of a meal report for this guide.
   */
  report = 'report',
  /**
   * The total number of days for which the user had a sensor running, excluding the calibration period.
   */
  measurementdays = 'measurementdays',
  /**
   * The number of days/weeks/months
   */
  duration = 'duration',
}
